module.exports = __webpack_public_path__ + "img/long-arrow-right-regular.bfab2b59.svg";